module.exports = __webpack_public_path__ + "static/media/cloud-showers.47bcced6.svg";